// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-account-settings-branding-preview-pages-module__pageList--yqyK7 {
  margin: 0px;
}

.src-js-account-settings-branding-preview-pages-module__pageList--yqyK7 li {
  margin-bottom: 5px;
}

.src-js-account-settings-branding-preview-pages-module__pageList--yqyK7 li a {
  color: white;
}

.src-js-account-settings-branding-preview-pages-module__pageList--yqyK7 li a i {
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/js/account/settings/branding/preview-pages.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".pageList {\n  margin: 0px;\n}\n\n.pageList li {\n  margin-bottom: 5px;\n}\n\n.pageList li a {\n  color: white;\n}\n\n.pageList li a i {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageList": `src-js-account-settings-branding-preview-pages-module__pageList--yqyK7`
};
export default ___CSS_LOADER_EXPORT___;
